import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';
import { QMS_CATEGORY_LABELS } from '../../constants/labels';

export type QmsCategoryStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getQmsCategoryStatusDialogConfig(
  categoryName: string,
  isActive: boolean
): QmsCategoryStatusDialogConfig {
  const isActivating = !isActive;

  return {
    title: isActivating
      ? QMS_CATEGORY_LABELS.STATUS_DIALOG_ACTIVATE_TITLE
      : QMS_CATEGORY_LABELS.STATUS_DIALOG_DEACTIVATE_TITLE,
    content: isActivating ? (
      <>
        <span>{QMS_CATEGORY_LABELS.STATUS_DIALOG_ACTIVATE_PREFIX}</span>
        <span className="font-medium">{categoryName}</span>
        <span>{QMS_CATEGORY_LABELS.STATUS_DIALOG_ACTIVATE_SUFFIX}</span>
      </>
    ) : (
      <>
        <span>{QMS_CATEGORY_LABELS.STATUS_DIALOG_DEACTIVATE_PREFIX}</span>
        <span className="font-medium">{categoryName}</span>
        <span>{QMS_CATEGORY_LABELS.STATUS_DIALOG_DEACTIVATE_SUFFIX}</span>
      </>
    ),
    confirmButtonLabel: isActivating
      ? QMS_CATEGORY_LABELS.STATUS_DIALOG_CONFIRM_ACTIVATE
      : QMS_CATEGORY_LABELS.STATUS_DIALOG_CONFIRM_DEACTIVATE,
    confirmButtonLabelLoading: isActivating
      ? QMS_CATEGORY_LABELS.STATUS_DIALOG_CONFIRM_ACTIVATING
      : QMS_CATEGORY_LABELS.STATUS_DIALOG_CONFIRM_DEACTIVATING,
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
